export default "__VITE_ASSET__V74PNIZX__"